import React from 'react';
import { Container, Nav, Navbar } from 'react-bootstrap';

const Header = () => {
    return (
        <div>
            
            <Navbar bg="" variant="dark" style={{backgroundColor:'rgb(30, 30, 40)'}}>
              <Container>
              <Navbar.Brand href="#home"><i class="fas fa-infinity"></i></Navbar.Brand>
              <Nav className="me-auto">
                <Nav.Link href="#about">About</Nav.Link>
                <Nav.Link href="#contact">Cotact</Nav.Link>
                <Nav.Link href="#projects">Projects</Nav.Link>
              </Nav>
              </Container>
            </Navbar>
            
        </div>
    );
};

export default Header;